module.exports = __webpack_public_path__ + "static/Stripe-7a999e26638b36a1b7435fda1a10aaea.jpg";